import React, {useEffect, useMemo, useState} from 'react';
import InfiniteCalendar, {withRange, Calendar} from 'react-infinite-calendar';
import zhCN from 'date-fns/locale/zh-CN'

import './s.scss';
import './d.scss'

const fixD = (a = 0, b = 0) => {
    const no = new Date();
    return new Date(no.getFullYear(), no.getMonth() - b, no.getDate() - a)
}
export const simpleDate = a => {
    const n = new Date().getFullYear()
    return a.replace(n + '年', '').replace(n, '')
}

export const fixD2 = k => {
    const d = new Date(k);
    return d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日';
}
export const fixD3 = k => {
    return simpleDate(fixD2(k))
}

export const dateStr = (v, suffix = '') => {
    if (typeof v === 'string') v = v.replace(/-/gi, '/')
    const d = v ? new Date(v) : new Date();
    const c = c => (c + 100 + '').substr(1);
    return [d.getFullYear(), c(d.getMonth() + 1), c(d.getDate())].join('-') + suffix
}
const parseDate = (v) => {
    const n = new Date()
    const [yy, mm, dd] = [n.getFullYear(), n.getMonth(), n.getDate()]
    if (Array.isArray(v)) {
        const [a, b, c] = v;
        return new Date(yy - a, mm - b, dd - c);
    } else {
        switch (v) {
            case 1:
                return new Date(yy, mm, dd)
            case 2:
                return new Date(yy, mm, dd - 1)
            case 7:
                return new Date(yy, mm, dd + 1 - n.getDay())
            case 30:
                return new Date(yy, mm, 1);
            default:
                return n;
        }
    }
}
const fmtRange = (a, b) => {
    return [
        parseDate(a),
        parseDate(b)
    ]
}

const u = (v, b, f) => {
    if (v !== undefined && v !== b) f(v)
}
const base = {
    show: 0,
    value: [],
}

const set = {
    _cur: {},
    get cur() {
        return this._cur
    },
    set cur(v) {
        this._cur = v;
        if (this.changeState) this.changeState(v);
    },
    changeState: null,
};

export function useXDate(cfg = {}) {
    const ctx = useMemo(() => ({...base, ...cfg}), [cfg]);
    return i => {
        const h = window.innerHeight;
        const [a, b] = ctx.limit || [];
        const o = {
            height: h > 900 ? undefined : h - 300,
            ...ctx,
            show: i
        };
        if (a) o.min = fixD(-a);
        if (b) o.max = fixD(-b);
        set.cur = o;
    }
}

export const XDate = () => {
    const {
        range = 1,
        max = 0, min = 0, value = range ? [] : '', show, height
    } = set.cur;
    const [r, rr] = useState(range);
    const [ma, mma] = useState(max);
    const [mi, mmi] = useState(min);
    const [v, vv] = useState(value);
    const [s, ss] = useState(show);
    const [x, aa] = useState(s);
    const [h, hh] = useState(height);
    const local = {
        locale: zhCN,
        blank: '请选择日期...',
        headerFormat: 'MM-DD',
        todayLabel: {
            long: '今天',
        },
        weekdays: ['日', '一', '二', '三', '四', '五', '六'],
        weekStartsOn: 1,
    };
    set.changeState = g => {
        const {
            max, min, value, show, range
        } = g;
        u(max, ma, mma);
        u(min, mi, mmi);
        u(value, v, vv);
        u(show, s, ss);
        u(height, h, hh);
        u(range, r, rr);
        aa(0);
    }
    useEffect(() => {
        const t = setTimeout(() => aa(s), s ? 10 : 300)
        return () => clearTimeout(t);
    }, [s])
    useEffect(() => {
    }, [x])
    let [a, b] = [].concat(v);
    a = a ? new Date(a) : new Date();
    b = b ? new Date(b) : new Date();
    const o = useMemo(() => {
        const x = {
            height: h,
            locale: local,
            selected: a,
            onSelect: (v) => {
                const {onChange} = set.cur;
                if (!range) {
                    vv(v);
                    if (onChange) onChange(v);
                    ss(0);
                } else {
                    const {eventType, end, start} = v;
                    if (eventType === 3 || (eventType === undefined && end && start)) {
                        const b = [start, end];
                        vv(b);
                        if (onChange) onChange(b);
                        ss(0);
                    }
                }
            },
        };
        if (r) {
            x.Component = withRange(Calendar);
            x.selected = {
                start: a,
                end: b
            }
        }
        return x;
    }, [v])
    if (mi) o.minDate = new Date(mi);
    if (ma) o.maxDate = new Date(ma);
    return <div className={'x-date' + (s ? ' a' : '') + (x ? ' b' : '')}
                onClick={({target, currentTarget}) => {
                    if (currentTarget === target) ss(0)
                }}>
        <div className={'x-dd'}>
            <InfiniteCalendar {...o}/>
        </div>
    </div>
}


export const XDatePicker = ({
                                readOnly,
                                limit = [],
                                quick,
                                quickName = [],
                                init,
                                value,
                                single,
                                onChange, children
                            }) => {
    const [v, vv] = useState(value || (single ? '' : []));
    const [a, b] = [].concat(v);
    const show = useXDate({
        range: !single,
        limit: limit,
        value: v,
        onChange: v => vv(v)
    });
    const [se,sse]=useState(-1)
    let q = null;
    const fns = [];
    if (!single && quick && quick.length) {
        const j = [];
        quick.forEach((v, i) => {
            let a = '';
            let t = quickName[i];
            if (t) a = t;
            else switch (v) {
                case  1:
                    a = '今';
                    break;
                case  2:
                    a = '昨';
                    break;
                case  -7:
                case  7:
                    a = '周';
                    break;
                case  -30:
                case  30:
                    a = '月';
                    break;
                default:
                    a = (v) + '天'
            }
            let c = [[0, 0, v], [0, 0, 0]];
            if (v === 1) c = [1, 1];
            if (v === 2) c = [2, 2];
            if (v === -7) c = [7, [0, 0, 0]];
            if (v === -30) c = [30, [0, 0, 0]]
            if (v === 30) c = [[0, 1, 0], [0, 0, 0]]
            j.push([c, a])
        })
        q = <div className={'x-dp-q'}>
            {j.map(([[x, y], n], i) => {
                const [star, end] = fmtRange(x, y);
                const  aa = dateStr(star) === dateStr(a) && dateStr(end) === dateStr(b)
                const act = se===-1?aa:i===se&&aa;
                const ck = () => {
                    sse(i)
                    vv(single ? star : [star, end])
                }
                fns.push(ck)
                return <div key={i}
                            className={act ? 'act' : ''}
                            onClick={ck}
                >{n}</div>
            })}
        </div>
    }
    useEffect(() => {
        if (fns[init]) fns[init]();
    }, [init, fns.length])
    const obj = useMemo(() => ({}), [])
    useEffect(() => {
        clearTimeout(obj.id);
        obj.id = setTimeout(() => {
            const va = value || (single ? '' : []);
            if (onChange && (single ? (va !== v) : (va[0] !== v[0] && va[1] !== v[1]))) onChange(v)
        }, 100)
    }, [v])

    const s0 = dateStr(a);
    const mo = readOnly ? null : q
    const inline = quick && quick.length < 3
    return <div className={'x-dp' + (readOnly ? ' readonly' : '')}>
        <div className={'x-r'}>
            <div className={'x-dp-a'} onClick={readOnly ? null : () => show(1)}>
                <i/>
                <span>{s0}</span>
                {single ? null : <>
                    至
                    <span>{dateStr(b).replace(s0.substr(0, 5), '')}</span>
                </>}
                {readOnly ? null : <s/>}
            </div>
            {inline ? mo : null}
            {children}
        </div>
        {inline ? null : mo}
    </div>
}
